import { ContactDetails } from 'cpnl-common';
import { DataOverview } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NoConnectionNotification } from '../../../notifications/no-connection/NoConnectionNotification';
import { EditStatus } from '../edit-view/EditView';
import { ContactList } from './ContactList';
import { NotificationForEditStatus } from './NotificationForEditStatus';
import { changeContactDetailsPath } from '../../../navigation/paths';

export type NonEditViewProps = {
    contactDetails?: ContactDetails;
    startEditing: (event: MouseEvent) => void;
    editStatus: EditStatus;
};

export const NonEditView: React.FC<NonEditViewProps> = ({ contactDetails, startEditing, editStatus }) => {
    const { t } = useTranslation('my-profile');

    return (
        <DataOverview
            href={changeContactDetailsPath()}
            title={t('contact-details.sub-headline')}
            buttonLabel={t('contact-details.edit-button.label')}
            buttonProps={{
                onClick: startEditing,
                testId: 'editButton',
                'aria-label': t('contact-details.edit-button.aria-label'),
                title: t('contact-details.edit-button.title'),
            }}
            titleLevel={3}
        >
            {!contactDetails ? (
                <NoConnectionNotification testId="identification-no-connection-error" />
            ) : (
                <>
                    <ContactList contactDetails={contactDetails} />
                    <NotificationForEditStatus editStatus={editStatus} />
                </>
            )}
        </DataOverview>
    );
};
